import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import React, { Component } from 'react';
import { connect } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import creditcardlogo from "../../images/credit-cards-vector-icon-.jpg";
import '../../stylesheet/transfer.css';
import LeftLink from '../leftlink/leftlink.jsx';
import Loader from '../loader/loader.jsx';

import AuthNavbar from '../navigation/authnavigation.jsx';

const styles = {
    block: {
        maxWidth: 250,
    },
    radioButton: {
        marginBottom: 5,
        marginTop: 5,
        width: "33%",
        display: "inline"
    },
    blockmargin: {
        marginBottom: 10,
        marginRight: 10
    },
    labelStyle: {
        padding: 0,
        color: "#fff",
        marginTop: 20
    },
    inputStle: {
        marginRight: 5,
        marginTop: 10
    },
    groupstyle: {
        display: "flex",
        width: "100%"
    },
    radioIcon: {
        fill: "#333"
    },
    calendarStyle: {
        // backgroundColor:"#333"
    },
    calendarTextStyle: {
        color: "#fff",
        // backgroundColor:"#333"
    }
};
const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    profileState: state.getProfileReducer.profileState,
    cardState: state.getCardReducer.cardState,
    transHistory: state.getTransferHistory.transHistory,
    rowData: state.storeRowDetail.rowData
})
const mapDispatchToProps = dispatch =>
({
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },
    fetchTransferHistory(cardDetailId, startDate, endDate, status) {

        dispatch(
            actions.getTransferHistory(cardDetailId, startDate, endDate, status)
        )
    },
    storeHistoryRowData(state) {
        dispatch(
            actions.stoteRowDetail(state)
        )
    }
})


class TransferHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardAccount: 1,
            show: "P",
            historyType: '',
            statementFromDate: new Date(),
            statementTodDate: new Date(),
            status: '',
            loader: true,
            selectedCard: [],
            disabled: true,
            todate: true,
            controlledDate: null,
            cardInUse: [],
            filteredCards: []
        }
    }

    handleSelect = (event, index, value) => {
        const { filteredCards } = this.state
        for (let i = 0; i < filteredCards.length; i++) {
            if (filteredCards[i].cardDetailsId === value) {
                this.setState({
                    cardInUse: filteredCards[i],
                    selectedCard: filteredCards[i],
                })
            }
        }
        this.setState({ cardAccount: value }, () => {
            for (let i = 0; i < filteredCards.length; i++) {
                if (this.state.cardAccount === filteredCards[i].cardDetailsId) {

                    this.setState({

                        selectedCard: filteredCards[i]
                    }, () => {

                        this.setState({
                            loader: true
                        }, () => {
                            this.props.fetchTransferHistory(value, this.state.statementFromDate, this.state.statementTodDate, this.state.show)

                            this.setState({
                                loader: false
                            })
                        })
                    })
                }
            }
        });

        // this.setState({ cardAccount: value }, () => {
        //     loader: true
        //     this.props.fetchTransferHistory(this.state.cardAccount, this.state.statementFromDate, this.state.statementTodDate, this.state.show)
        // });

    }
    // componentWillReceiveProps(nextProps) {

    //     this.setState({
    //         loader: true
    //     })
    //     try {
    //         if (nextProps.cardState && nextProps.cardState.length !== 0) {

    //             var filteredR = nextProps.cardState.body.filter((val) => {
    //                 return (val.cardType === "R")
    //             })
    //             var filteredCards = filteredR

    //             this.setState({
    //                 loader: false,
    //                 cardAccount: filteredCards[0].cardDetailsId,
    //                 selectedCard: filteredCards[0],
    //                 filteredCards: filteredCards,
    //                 cardInUse: filteredCards[0],
    //             })
    //         }
    //     } catch (e) {

    //     }

    // }
    handleDateChange = (date) => {
        this.setState({
            controlledDate: date,
        });
        return date;
    };
    handleSelect1 = (event, index, value) => this.setState({ show: value }, () => {
        this.setState({
            loader: true
        })
        this.props.fetchTransferHistory(this.state.cardAccount, this.state.statementFromDate, this.state.statementTodDate, this.state.show)
    },
        this.setState({
            loader: false
        })
    );
    handleFromDate = (e, date) => {
        let newDate = this.converDate(date)
        this.setState({
            statementFromDate: newDate
        }, () => {

            if (this.state.statementFromDate.length !== 0 && this.state.statementTodDate.length !== 0) {
                this.setState({
                    disabled: false

                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        })
    }
    handleToDate = (e, date) => {

        this.setState({
            statementTodDate: this.converDate(date)

            // dob: this.converDate(date)
        }, () => {

            if (this.state.statementFromDate.length !== 0 && this.state.statementTodDate.length !== 0) {
                this.setState({
                    disabled: false

                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        }
        )
    }
    converDate(date) {

        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [


            (mm > 9 ? '' : '0') + mm,
            (dd > 9 ? '' : '0') + dd,
            date.getFullYear()
        ].join('/');
    }

    handleChangeMinDate = (event, date) => {
        this.setState({
            statementFromDate: this.converDate(date),
        });
    };

    componentDidUpdate(prevProps) {

    }
    removetodate = () => {
        this.setState({
            todate: true
        })
    }
    handleChangeMaxDate = (event, date) => {
        this.setState({
            statementTodDate: date,
        });
    }
    // handleHistory = () => {
    //     if (Date.parse(this.state.statementTodDate) <= Date.parse(this.state.statementFromDate)) {
    //         this.setState({
    //             todate: false,
    //         })
    //     }
    //     else {


    //         this.setState({
    //             applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
    //             cardDetailsId: this.state.cardAccount,
    //             historyType: "P",
    //             statementFromDate: this.state.statementFromDate,
    //             statementTodDate: this.state.statementTodDate,
    //             status: "P"
    //         }, () => {
    //             this.setState({
    //                 loader: true
    //             })
    //             this.props.fetchTransferHistory(this.state.cardAccount, this.state.statementFromDate, this.state.statementTodDate, this.state.show)

    //         }, () => {
    //             this.setState({
    //                 loader: false
    //             })
    //         })
    //     }
    // }
    handleHistory = () => {

        if (Date.parse(this.state.statementTodDate) < Date.parse(this.state.statementFromDate)) {

            this.setState({
                todate: false,
            })
        }
        else {

            this.setState({
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                cardDetailsId: this.state.cardAccount,
                // historyType: "P",
                statementFromDate: this.state.statementFromDate,
                statementTodDate: this.state.statementTodDate,
                // status: "P"

            }, () => {
                this.setState({
                    loader: true
                }, () => {
                    this.props.fetchTransferHistory(this.state.cardAccount, this.state.statementFromDate, this.state.statementTodDate, this.state.show)

                    this.setState({
                        loader: false
                    })
                })
            })
        }
    }

    removetodate = () => {
        this.setState({
            todate: true
        })
    }
    formatDate = (date) => {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        return [

            (dd > 9 ? '' : '0') + dd,
            (mm > 9 ? '' : '0') + mm,
            date.getFullYear()
        ].join('/');
    }
    handleCardClick(state) {
        this.setState({
            selectedCard: state
        }, () => {
            this.setState({
                useClass: "tile"
            })
            document.getElementById("tilediv").style.display = "block"
        })
    }
    handleDownload() {
        const input = document.getElementById('TransferdivPrint');
        html2canvas(input)
            .then((canvas) => {
                const img = canvas.toDataURL('image/png');
                //const pdf = new jsPDF('p', 'mm');
                //let img = pdf.addImage(imgData, 'JPEG', 0, 0);
                var logoImg = 'data:image/png;base64,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'
                var imgWidth = 210;
                var pageHeight = 395;
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;

                const pdf = new jsPDF('p', 'mm')
                pdf.setFontSize(10);

                var position = 40;
                //pdf.text(cardState.firstName, 10, 10)
                //addImage(imageData, format, x, y, width, height, alias, compression, rotation)
                //pageHeight setting up pages to multiple pages across
                pageHeight= pdf.internal.pageSize.height;  

                pdf.addImage(logoImg, 'PNG', 10, 5, 38, 10);
                // left , top 
                pdf.text(`Name:      ${this.state.selectedCard.firstName} ${this.state.selectedCard.lastName}` , 10, 25)
                pdf.text(`Address:   ${this.props.profileState.body.address}, ${this.props.profileState.body.address2},` , 10, 30)
                pdf.text(` ${this.props.profileState.body.city} ${this.props.profileState.body.state}` , 26, 35)
                
                // if (35>=pageHeight)
                // {
                // pdf.addPage();
                // }

                pdf.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    pdf.addPage();
                    pdf.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
           
                }
                  setTimeout(() => {
                        pdf.save("download.pdf");
                        this.setState({ quickLoad: false })
                    }, 2000)
            })
            ;
    }

    componentDidMount() {
        let _this = this
        const { statementFromDate, statementTodDate } = this.state
        const { cardState } = this.props
        // if (cardState && cardState.length !== 0) {

        //     var filteredR = cardState.body.filter((val) => {
        //         return (val.cardType === "R")
        //     })
        if (cardState && cardState.body && cardState.body.length > 0) {
    const filteredR = cardState.body.filter((val) => val.cardType === "R");

    if (filteredR.length === 0) return;
            let filteredCards = filteredR

            this.setState({
                loader: false,
                cardAccount: filteredCards[0].cardDetailsId,
                selectedCard: filteredCards[0],
                filteredCards: filteredCards,
                cardInUse: filteredCards[0],
                statementFromDate: statementFromDate.setMonth(statementFromDate.getMonth() - 3),
            }, () => {

                _this.setState({
                    loader: true,
                    statementTodDate: statementTodDate.toLocaleDateString(),
                    statementFromDate: statementFromDate.toLocaleDateString()
                }, () => {
                    _this.props.fetchTransferHistory(_this.state.cardAccount, statementFromDate.toLocaleDateString(), statementTodDate.toLocaleDateString(), _this.state.show)
                    _this.setState({
                        loader: false
                    })
                })
            })
        }

        // .then(response => {
        //     if (response.status === 200 || response.status === 201 || response.status === 204) {
        //         this.setState({
        //             loader: false
        //         })                   
        //     } else {
        //         toast.error(response.headers.get('message'), {
        //             position: "top-right",
        //             draggablePercent: 60,
        //             autoClose: 3000,
        //             hideProgressBar: false,
        //             closeOnClick: true,
        //             pauseOnHover: true,
        //             draggable: false
        //         });
        //         this.setState({
        //             loader: false
        //         })

        //     }
        // })

        // document.getElementById("errordiv").style.display = response.headers.get('message');


    }
    handleDownload1() {
        const input = document.getElementById('recurringdivPrint');
        html2canvas(input)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                pdf.addImage(imgData, 'JPEG', 0, 0);
                // pdf.output('dataurlnewwindow');
                pdf.save("download.pdf");
            })
            ;
    }
    handleView(state) {

        this.props.storeHistoryRowData(state)
        localStorage.setItem('rowdata', JSON.stringify(state))

    }
    render() {
        const { cardState, transHistory, rowData } = this.props
        const { cardAccount, selectedCard, todate, cardInUse, filteredCards } = this.state

        return (
            <div>
                <div className="row">
                    <div className="col-sm-12 m-0 p-0">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container transfer" style={{}}>
                    <div className="row">
                        {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                        <LeftLink />
                    </div> */}
                        <div className="modal fade" id="editview">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header" >
                                        <h5 className="modal-title" style={{ color: "#333" }}>
                                            Share Funds - View</h5>
                                        <button type="button" className="close" data-dismiss="modal" style={{ color: "#333" }}>&times;</button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-sm-12 " style={{ fontSize: "14px" }} >

                                                <div className="col-sm-12" >
                                                    <h5>Transfer Details</h5>
                                                </div>
                                                <div className="col-sm-12" >
                                                    <div className="row" style={{ marginTop: "10px" }}>

                                                        <div className=" col-sm-5  tilepadding">
                                                            <label className="tilecontent"> Transfer ID  </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">{rowData.transactionId}  </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className=" col-md-5  tilepadding">
                                                            <label className="tilecontent">Status </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">{rowData.status} </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className=" col-md-5  tilepadding">
                                                            <label className="tilecontent">Card Account (From)  </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">{rowData.cardProgramId} {rowData.fromaccountNumber}  {rowData.balance} </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-5  tilepadding">
                                                            <label className="tilecontent">Kit Number (To) </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername"> {rowData.otherKitNo}   </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-5  tilepadding">
                                                            <label className="tilecontent">Debit Amount </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername"> {rowData.amount}  </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-5  tilepadding">
                                                            <label className="tilecontent">Transfer Date  </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">{rowData.transferDate} </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-5  tilepadding">
                                                            <label className="tilecontent">Comments  </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">{rowData.comments}  </span><br />
                                                        </div>
                                                    </div>
                                                    <div className=" offset-sm-4 col-sm-2" >
                                                        <RaisedButton
                                                            label="Close"
                                                            className="btn-std"
                                                            backgroundColor="#FFCE39"
                                                            labelColor="#115876"
                                                            data-dismiss="modal"
                                                            style={{ marginTop: "10px", backgroundColor: "#333 !important" }}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-dismiss="modal" onClick={this.handleSubmit.bind(this)}>Submit</button>
                        </div> */}

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12" style={{ padding: "0px 30px" }}>
                            <div className="row " style={{ padding: "12px 0px", minHeight: "476px" }}>


                                <div className="col-sm-12">
                                    <div className='row'>
                                        <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                            <h4 className='logmainheading mainheading'>
                                                Transfer History
                                            </h4>
                                            <p>
                                                Search for the history of a specific transfer or view the history of all transfers from this screen. Find transfer account information to include where money was transferred from and to, amount transferred, type of transfer, date of transfer, and its status. In addition, account information can be edited or cancelled.

                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-sm-12">
                                    <div className="search-history">
                                        <div className="row">
                                            {/* <div className="col-sm-3" style={{ marginTop: "38px" }}>
                                                <h5>Search</h5>
                                            </div> */}

                                            {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 && filteredCards.length !== 0 &&

                                                <div className="col-sm-12">
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            <div className="row">
                                                                {/* <div className="col-sm-4" style={{ marginTop: "35px", fontSize: "16px", fontWeight: "bold", color: "#585555", }}>
                                                                    {selectedCard.cardProgramId}
                                                                </div> */}

                                                                <div className="col-sm-12" >
                                                                    {filteredCards.length !== 0 &&
                                                                        <SelectField
                                                                            // floatingLabelText="Card Number"
                                                                            onChange={this.handleSelect}
                                                                            className="input-width"
                                                                            name="cardAccount"
                                                                            autoComplete='none'
                                                                            value={cardAccount}
                                                                        >
                                                                            {filteredCards.map((value, i) =>
                                                                                <MenuItem className="menuitem" value={filteredCards[i].cardDetailsId} primaryText={filteredCards[i].cardNumber} key={i} />
                                                                            )}
                                                                        </SelectField>}
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                               
                                            }
                                        </div>
                                    </div>
                                </div>
                                {cardState.status === 200 ?
                                    <div className="col-sm-12" style={{ marginTop: "20px" }}>
                                        <div className="row">
                                            <div className="col-sm-4" style={{ marginTop: "21px" }}>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 input-icon" >
                                                        <i className="fa fa-calendar text-dark " aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10 nopadding" >
                                                        <DatePicker
                                                            openToYearSelection={true}
                                                            hintText="From Date"
                                                            container="inline"
                                                            name="statementFromDate"
                                                            className="input-width"
                                                            defaultDate={this.state.statementFromDate}
                                                            formatDate={this.formatDate}
                                                            onChange={this.handleFromDate}
                                                            style={styles.calendarStyle}
                                                            maxDate={new Date()}
                                                            textFieldStyle={styles.calendarTextStyle}
                                                        />

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4" style={{ marginTop: "21px" }}>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 transferbutton" >
                                                        <i className="fa fa-calendar text-dark " aria-hidden="true" ></i>
                                                    </div>
                                                    <div className="col-sm-10 nopadding" >
                                                        <DatePicker hintText="To Date"
                                                            openToYearSelection={true}
                                                            onChange={this.handleToDate}
                                                            container="inline"
                                                            name="statementTodDate"
                                                            defaultDate={this.state.statementTodDate}
                                                            formatDate={this.formatDate}
                                                            onFocus={this.removetodate}
                                                            maxDate={new Date()}
                                                            className="input-width"
                                                            errorText={todate ? null : "To-date should not less than from-date."} />

                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-sm-4 nopadding text-center" style={{ marginTop: "10px" }}>
                                                {/* <div className="row">
                                                    <div className="col-sm-2 input-icon" >
                                                        <img src={creditcardlogo} alt="" />
                                                    </div>
                                                    <div className="col-sm-9" >

                                                        <SelectField
                                                            floatingLabelText="Transfer Status"
                                                            onChange={this.handleSelect1}
                                                            className="input-width"
                                                            name="show"
                                                            autoComplete='none'
                                                            value={this.state.show}
                                                        >

                                                            <MenuItem value="P" primaryText="Processed" />
                                                            <MenuItem value="M" primaryText="Manual" />
                                                            <MenuItem value="C" primaryText="Cancelled" />
                                                            <MenuItem value="R" primaryText="Deferred" />


                                                        </SelectField>
                                                    </div>
                                                </div> */}
                                                <RaisedButton
                                                    label="Show"
                                                    className="pull-left btn-std"
                                                    disabled={this.state.disabled}
                                                    // style={styles.button}
                                                    backgroundColor="#FFCE39"
                                                    labelColor="#115876"
                                                    onClick={this.handleHistory}
                                                    style={{ marginTop: "10px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                : <Loader />     
                                }
                                {/* <div className="col-sm-12">
                                    <div className="offset-md-4 col-md-2 text-center">
                                        <RaisedButton
                                            label="Show"
                                            className="pull-right"
                                            disabled={this.state.disabled}
                                            // style={styles.button}
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            onClick={this.handleHistory}
                                            style={{ marginTop: "10px" }}
                                        />
                                    </div>
                                </div> */}
                                {/* <div className="col-sm-12 " style={{ marginTop: "30px" }}>

                                    <div className="btn-pref btn-group btn-group-justified btn-group-sm transfer" role="group" aria-label="...">
                                        <div className="btn-group" role="group">
                                            <button type="button" id="stars" className="btn btn-secondary btn-sm" href="#tab1" data-toggle="tab" onClick={this.showdefault}>
                                                <div className="hidden-xs">Transfer History</div>
                                            </button>
                                        </div>
                                        <div className="btn-group" role="group">
                                            <button type="button" id="favorites" className="btn btn-default btn-sm" style={{ width: "95%" }} href="#tab2" data-toggle="tab" onClick={this.showcustomized}>
                                                <div className="hidden-xs">Recurring Transfer History </div>
                                            </button>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="col-sm-12 transfer mb-3" style={{ marginTop: "30px" }}>
                                    <div className="pull-right">
                                        <button className="btn-std " onClick={this.handleDownload.bind(this)} style={{ marginBottom: 10,  fontSize: 14}}> Download as PDF</button>
                                    </div>
                                    <h5>
                                        Transfer History
                                    </h5>
                                    {
                                      this.state.loader ? <div><Loader /></div> :
                                        cardState.status === 200 && cardInUse.length !== 0 && cardInUse.cardStatus === "Inactive/Blocked Card" ? <div className="text-center" style={{ marginTop: "20px" }}>Selected Card is Inactive/Blocked.</div> : transHistory.status === 200 ?
                                            <table className="table table-striped mb-4" id="TransferdivPrint">
                                                <thead className='table-dark'>
                                                    <tr style={{ fontSize: "13px" }}>
                                                        <th className="nopaddingleft">Transfer ID	</th>
                                                        <th>Account (From)</th>
                                                        <th>Account (To)</th>
                                                        <th className="nopaddingright" >Amount</th>
                                                        <th>Transfer Date</th>
                                                        <th>Status</th>
                                                        <th>Options</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {transHistory.body.transactions.length !== 0 && transHistory.body.transactions.map((value, i) =>
                                                        <tr style={{ fontSize: "13px" }} key={i}>
                                                            <td>{transHistory.body.transactions[i].transactionId}</td>
                                                            <td>{transHistory.body.transactions[i].fromAccount} { }
                                                                {transHistory.body.transactions[i].lastFourDigitsCardNumber} </td>
                                                            <td>{transHistory.body.transactions[i].toAccount}  </td>
                                                            <td> {transHistory.body.transactions[i].amount}</td>
                                                            <td>{transHistory.body.transactions[i].transferDate}</td>
                                                            <td>{transHistory.body.transactions[i].status}</td>
                                                            <td className="pseudolink" ><span aria-hidden="true" data-toggle="modal" data-target="#editview" onClick={() => { this.handleView(transHistory.body.transactions[i]) }} style={{ color: "#333", cursor: "pointer" }}> View </span> </td>
                                                        </tr>
                                                    )}
                                                    {transHistory.status === 200 && transHistory.body.transactions.length === 0 &&
                                                        <tr >
                                                            <td colSpan="7">No Records Found</td>
                                                        </tr>}

                                                </tbody>
                                            </table>
                                            : <div> : <Loader />  </div>}

                                    {transHistory.status === 500 && this.state.loader === false &&
                                        <tr >
                                            <td colSpan="7">No Records Found</td>
                                        </tr>}
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div >
        );
    }
}
TransferHistory.defaultProps = {
    cardState: {
        status: 600
    },
    transHistory: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferHistory);


// WEBPACK FOOTER //
// ./src/components/transferfunds/transferhistory.jsx